import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { styled } from "@mui/material/styles";
import { Link, Container, Typography, Grid } from "@mui/material";
import useResponsive from "../../../hooks/useResponsive";
import Logo from "../../../components/Logo";
import Form from "./Form";
import LanguagePopover from "../../../layouts/dashboard/header/LanguagePopover";
import { ClientVerified } from "./ClientVerified";

const StyledRoot = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const StyledSection = styled("div")(({ theme }: any) => ({
  width: "100%",
  maxWidth: 480,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled("div")(({ theme }) => ({
  // maxWidth: 480,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));

export const RegisterPage = () => {
  const { t } = useTranslation();
  const mdUp = useResponsive("up", "md");
  const navigate = useNavigate();
  const [isVerified, setIsVerified] = useState(false);

  return isVerified ? (
    <ClientVerified />
  ) : (
    <Fragment>
      <Helmet>
        <title>{`${t("Register")} | ${t("AppTitle")}`}</title>
      </Helmet>

      <StyledRoot>
        <Logo
          sx={{
            position: "fixed",
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        />

        {mdUp && (
          <StyledSection>
            <Grid sx={{ position: "fixed", top: "25%", maxWidth: "480px" }}>
              <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
                {t("HiWelcome")}
              </Typography>
              <img
                src="/assets/illustrations/illustration_login.png"
                alt={t("Register").toString()}
              />
            </Grid>
          </StyledSection>
        )}

        <Container maxWidth="lg" sx={{ ml: 2, mr: 2 }}>
          <StyledContent>
            <Typography variant="h5" gutterBottom>
              {t("Registerinto")}
            </Typography>

            <Typography variant="body2" sx={{ mb: 5 }}>
              {t("Alreadyhaveanaccount")} {""}
              <Link
                variant="subtitle2"
                sx={{ cursor: "pointer" }}
                onClick={() => navigate("/login")}
              >
                {t("Login")}
              </Link>
            </Typography>

            <Form setIsVerified={setIsVerified} />
          </StyledContent>
        </Container>
      </StyledRoot>

      <span style={{ position: "fixed", top: "10px", right: "10px" }}>
        <LanguagePopover />
      </span>
    </Fragment>
  );
};
